import {createContext} from 'react'

export const SearchContext = createContext({
    paymail: 'johndifelice@moneybutton.com'
});